import React from 'react';
import { GameState, NewsItem, DisplayFixture } from '../../domain/entities';
import { View } from '../../App';
import { LinkedText } from '../shared/LinkedText';
import { Modal } from '../shared/Modal';
import './PlayerDetailModals.css';

export const NewsModal: React.FC<{ item: NewsItem | null, onClose: () => void, gameState: GameState, pushView: (view: View) => void }> = ({ item, onClose, gameState, pushView }) => {
    if (!item) return null;
    return (
        <Modal isOpen={!!item} onClose={onClose}>
            <h2>{item.title}</h2>
            <LinkedText text={item.message} gameState={gameState} pushView={pushView} onClose={onClose} as="p" style={{whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: '16px'}}/>
            
            {item.fixtureData && (
                 <div className="news-modal-fixture-result">
                    <span>{item.fixtureData.home}</span>
                    <span className="match-result">{item.fixtureData.result?.homeScore} - {item.fixtureData.result?.awayScore}</span>
                    <span>{item.fixtureData.away}</span>
                </div>
            )}
            
            {item.playerRetirementData && (
                <div className="table-wrapper" style={{marginTop: '16px'}}>
                    <table className="table">
                        <thead>
                            <tr><th>Player</th><th>Games</th><th>Goals</th></tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{item.playerRetirementData.player.name}</td>
                                <td>{item.playerRetirementData.totalGames}</td>
                                <td>{item.playerRetirementData.totalGoals}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div className="modal-actions">
                {item.link && <button className="button" onClick={() => { onClose(); pushView(item.link!); }}>View</button>}
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
